import { notification } from 'antd';

export const showNotification = ({
  key,
  type,
  onClick,
  message,
  duration,
  description,
}) => notification[type]({
  key,
  duration,
  onClick: () => {
    onClick();
    notification.close(key);
  },
  message,
  description,
  style: { right: '10px' },
});



// WEBPACK FOOTER //
// ./src/components/notification/index.js